const ITEMS = [
  "320KBPS AUDIO",
  "24/7 PLAYBACK",
  "SMART QUEUES",
  "SYNCED LYRICS",
  "ZERO-LAG NODES",
  "INTERACTIVE BUTTONS",
  "PERSONAL PLAYLISTS",
  "RADIO AUTOPLAY",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/10 bg-[#07070c] py-5 overflow-hidden select-none" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display text-xl sm:text-2xl font-700 px-8 ${i % 2 === 0 ? "text-outline" : "text-white/85"}`} style={{ fontWeight: 700 }}>
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-blurple shadow-[0_0_12px_rgba(88,101,242,0.9)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
